import Phaser from 'phaser'
import TextureKeys from './textureKeys';

interface TrailToData
{
    fromX: number
    fromY: number
    toX: number
    toY: number
}

export default class ParticleEffects extends Phaser.Scene
{
	constructor()
	{
		super('ParticleEffects');
	}

    create()
    {
        const particles = this.add.particles(TextureKeys.ParticleStar);

        this.events.on('trail-to', (data: TrailToData) => {
            const emitter = particles.createEmitter({
                x: data.fromX,
                y: data.fromY,
                quantity: 2,
                speed: { random: [50, 60] },
                lifespan: { random: [200, 400]},
                scale: { random: true, start: 1, end: 0 },
                rotate: { random: true, start: 0, end: 180 },
                angle: { random: true, start: 0, end: 270 },
                blendMode: 'ADD'
            });

            emitter.setScale(0.2);
            emitter.setAlpha(0.5);
            emitter.setQuantity(1);
    
            // const xVals = [data.fromX, 300, 100, data.toX]
            // const yVals = [data.fromY, 100, 150, data.toY]

            const xVals = [data.fromX, data.fromX - (data.fromX - data.toX)/2, data.fromX - (data.fromX - data.toX)/1.5, data.toX]
            const yVals = [data.fromY, data.fromY + 100, data.fromY + 50, data.toY]

            
            this.tweens.addCounter({
                from: 0,
                to: 1,
                ease: Phaser.Math.Easing.Sine.InOut,
                duration: 6000,
                onUpdate: tween => {
                    const v = tween.getValue()
                    const x = Phaser.Math.Interpolation.CatmullRom(xVals, v)
                    const y = Phaser.Math.Interpolation.CatmullRom(yVals, v)
    
                    emitter.setPosition(x, y)
                },
                onComplete: () => {
                    emitter.explode(5, data.toX, data.toY)
                    emitter.stop()
    
                    this.time.delayedCall(1000, () => {
                        particles.removeEmitter(emitter)
                    })
                }
            })
        })
    }
}